/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import type { TdTreeProps } from './type';

export const treeDefaultProps: TdTreeProps = {
  activable: false,
  activeMultiple: false,
  allowFoldNodeOnFilter: false,
  checkStrictly: false,
  checkable: false,
  data: [],
  disableCheck: false,
  empty: '',
  expandAll: false,
  expandLevel: 0,
  expandMutex: false,
  expandOnClickNode: false,
  expandParent: false,
  expanded: [],
  icon: true,
  label: true,
  lazy: true,
  line: false,
  transition: true,
  defaultValue: [],
  valueMode: 'onlyLeaf',
};
